import React from "react";
import PasswordResetForm from "../components/auth/PasswordResetForm";

const PasswordReset = () => {
  return <PasswordResetForm />;
};

PasswordReset.propTypes = {
  // PasswordReset component doesn't require props
};

export default PasswordReset;
